import { lightColors, darkColors } from "./styles/styles";
import Logo from "./assets/images/Logo";
const SplashImg = require(`./assets/splash/splash.png`)

export { lightColors, darkColors, Logo, SplashImg }